/* Ensure we have the tenantId in the url hash
     => If not, list available tenants and redirect if only one available
 */
(async function ensureTenantId() {
  try {
    // eslint-disable-next-line angular/window-service
    const locationMatchs = window.location.href.match(/#\/(.*?)(\/|$)/);
    const tenantId = locationMatchs?.[1] ?? '';
    if (!tenantId) {
      try {
        // List available tenants
        const result = await fetch('/aides/api/tenant-id');
        if (result.ok) {
          const tenant = await result.json();
          const availableTenantId = tenant?.tenantId;
          if (!availableTenantId) {
            throw new Error('Tenant ID is missing');
          }
          // eslint-disable-next-line angular/window-service
          window.location.hash = `/${availableTenantId}/`;
        }
      } catch (error) {
        console.error('Error loading available tenants', error);
        // eslint-disable-next-line angular/document-service
        const appDiv = document.querySelector('div[ui-view]');
        // eslint-disable-next-line angular/document-service
        const errorMessage = document.createElement('p');
        errorMessage.textContent = 'Merci de préciser le tenant';
        appDiv.appendChild(errorMessage);
      }
    }

    import('./main.js');
  } catch (fatalError) {
    console.log('Fatal error loading app', fatalError);
  }
})();
